
    
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaStatusProperties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IdeaStatusProperties"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stopVotesOnClosedIdeas"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"defaultStatusValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isIdeaStatusEnabled"},"arguments":[],"directives":[]}]}}]};
  

    
  var names = {};
  function unique(defs) {
    return defs.filter(function (def) {
      if (def.kind !== 'FragmentDefinition') return true;
      var name = def.name.value;
      if (names[name]) {
        return false;
      } else {
        names[name] = true;
        return true;
      }
    });
  };

  

    module.exports = doc
  
